import { useContext } from "react";
import Error404 from "../components/404";
import LanguageContext from "../context/language";
import UserContext from "../context/user";
import useAppLanguage from "../hooks/useAppLanguage";

const AppsError = () => {
  const { logged } = useContext(UserContext);
  const { defaultLabels, language, unloggedLanguage } = useContext(LanguageContext);
  const { labels } = useAppLanguage(
    defaultLabels,
    language,
    null,
    logged ? null : unloggedLanguage
  );
  return <Error404 labels={labels} />;
};

export default AppsError;
